import React from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Layout from "../components/layout"
import EbookHero from "../components/ebook-hero"
import SEO from "../components/seo"
import Container from "../components/container"
import FeynmanImg from "../images/ebooks/feynman.png"
import theme from "../consts/theme"
import { getEbooks } from "../utils"

const SC = {}

const EbookTecnicaFeynman = () => {
  const ebook = getEbooks("Técnica Feynman")

  return (
    <Layout>
      <SEO
        title={`[eBook] ${ebook.title}`}
        description={ebook.description}
        canonical={ebook.url.substring(1)}
        author="Apetrecho Digital"
      />
      <EbookHero
        cover={ebook.cover}
        title={`Aprenda a aprender
          <br />
          de verdade com a
          <br />
          Técnica Feynman`}
        description={`Conheça a técnica inspirada no físico
        <br />
        ganhador de um Prêmio Nobel que vai
        <br />
        ajudar você a <b>alcançar a aprendizagem
        <br />
        profunda</b> sobre tudo o que quiser!`}
        titlePrimaryColor="#fff"
        titleSecondaryColor="#fff"
        descriptionColor="#fff"
        leftBgColor={theme.colors.SECONDARY_PURPLE}
        rightBgColor="#fff"
        ebookTag={ebook.mailchimpTag}
        inputBgColor="#FFFFFF55"
      />
      <SC.Content
        isFlex
        alignItems="center"
        justifyContent="flex-start"
        flexDirection="row"
      >
        <SC.ContentTextWrapper>
          <SC.ContentTitle>Neste eBook você vai conferir:</SC.ContentTitle>
          <SC.ContentItems>
            <ul>
              <li>
                <FontAwesomeIcon
                  icon="check"
                  color={theme.colors.PRIMARY_GREEN}
                />
                <span>o que é a Técnica Feynman</span>
              </li>
              <li>
                <FontAwesomeIcon
                  icon="check"
                  color={theme.colors.PRIMARY_GREEN}
                />
                <span>quem foi Richard Feynman</span>
              </li>
              <li>
                <FontAwesomeIcon
                  icon="check"
                  color={theme.colors.PRIMARY_GREEN}
                />
                <span>os 4 passos da Técnica Feynman</span>
              </li>
            </ul>
          </SC.ContentItems>
        </SC.ContentTextWrapper>
        <SC.ContentImg src={FeynmanImg} alt="Richard Feynman" />
      </SC.Content>
    </Layout>
  )
}

SC.Content = styled(Container)`
  padding-top: 160px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.XS}) {
    padding: 40px 25px;
  }
`

SC.ContentTitle = styled.span`
  color: ${({ theme }) => theme.colors.PRIMARY_PURPLE};
  font-size: 32px;
  font-weight: 700;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.XS}) {
    font-size: 26px;
    text-align: center;
  }
`

SC.ContentTextWrapper = styled.div`
  margin-bottom: 100px;
  padding: 0 80px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.XS}) {
    padding: 0;
    margin-bottom: 380px;
  }
`

SC.ContentItems = styled.div`
  ul {
    list-style-type: none;
    margin: 0;
    margin-top: 40px;

    li {
      span {
        font-family: ${({ theme }) => theme.fonts.NUNITO};
        font-size: 22px;

        @media screen and (max-width: ${({ theme }) => theme.breakpoints.XS}) {
          font-size: 18px;
        }
      }

      svg {
        margin-right: 5px;
        height: 14px;
      }
    }
  }
`

SC.ContentImg = styled.img`
  margin: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 400px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.XS}) {
    width: 100%;
  }
`

export default EbookTecnicaFeynman
